import CardDefault from "components/Cards/CardDefault";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Skeleton } from "@chakra-ui/react";
import { Empty } from "antd";
import ItemReceita from "./../ItemReceita/index";
import { formatMoney } from "infra/helpers/number";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  RelatorioReceitasItem,
  TotaisRelatorioReceitas,
} from "core/features/relatorios/typings/index";
import InfiniteScrollLoader from "components/InfiniteScrollLoader";

interface RelatorioReceitasContentProps {
  data: RelatorioReceitasItem[];
  totais: TotaisRelatorioReceitas | undefined;
  fetchNextPage: () => any;
  hasNextPage: boolean;
  isLoading?: boolean;
  isFetchingNextPage?: boolean;
  isLoadingTotais?: boolean;
}

export default function RelatorioReceitasContent({
  data,
  totais,
  fetchNextPage,
  hasNextPage,
  isLoading,
  isFetchingNextPage,
  isLoadingTotais,
}: RelatorioReceitasContentProps) {
  const getTitle = () => {
    if (!totais?.totalUnidades) {
      return `Total (${totais?.totalCobrancas}${
        totais?.totalCobrancas === 1 ? " cobrança" : " cobranças"
      } de ${totais?.totalPessoas}${
        totais?.totalPessoas === 1 ? " pessoa" : " pessoas"
      })`;
    }

    return `Total (${totais?.totalCobrancas}${
      totais?.totalCobrancas === 1 ? " cobrança" : " cobranças"
    } de ${totais?.totalUnidades}${
      totais?.totalUnidades === 1 ? " unidade" : " unidades"
    })`;
  };

  return (
    <CardDefault
      mt={6}
      p={0}
      pt={"12px"}
      pb={data?.length && !isLoading ? 0 : "24px"}
    >
      {isLoadingTotais ? (
        <Flex px="16px">
          <Skeleton w="100%" h="24px" />
        </Flex>
      ) : (
        <Flex
          pl="16px"
          pr={6}
          justifyContent="space-between"
          alignItems="center"
        >
          <Flex>
            <Text fontWeight="bold">{getTitle()}</Text>
          </Flex>

          <Text fontWeight="bold">
            Total: {formatMoney(totais?.valorTotal)}
          </Text>
        </Flex>
      )}

      <Box mt={4}>
        {isLoading ? (
          <>
            <Skeleton w="100%" h="200px" />
          </>
        ) : null}

        {!isLoading && !data?.length ? (
          <Empty description="Sem relatório de receitas para o filtro selecionado." />
        ) : null}

        {!isLoading && data?.length ? (
          <>
            <InfiniteScroll
              dataLength={data?.length}
              next={() => {
                fetchNextPage();
              }}
              hasMore={!!hasNextPage}
              loader={isFetchingNextPage ? <InfiniteScrollLoader /> : null}
            >
              {data?.map((item) => (
                <ItemReceita item={item} key={item.unidadeId} />
              ))}
            </InfiniteScroll>
          </>
        ) : null}
      </Box>
    </CardDefault>
  );
}
